import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

import Icon from '../chrome/Icon';

const { flexCenter } = stylingHelpers;

const iconContainerBaseStyles = ({ theme }) =>
  css`
    border-radius: ${theme.borderRadius.circle};
    background-color: #367d61;
    width: 23px;
    height: 23px;
    ${flexCenter()}
  `;

const iconContainerErrorStyles = ({ theme, variant }) =>
  variant === 'error' &&
  css`
    border-color: ${theme.colors.r500};
    color: ${theme.colors.r500};
  `;

const iconContainerSuccessStyles = ({ theme, variant }) =>
  variant === 'success' &&
  css`
    border-color: ${theme.colors.white};
    color: ${theme.colors.white};
    padding: 0 0 1px 0;
  `;

const iconContainerSizeStyles = ({ size = 'giga' }) => {
  const sizeMap = {
    byte: {
      width: '16px',
      height: '16px',
    },
    giga: {
      width: '23px',
      height: '23px',
    },
    tera: {
      width: '25px',
      height: '25px',
    },
  };

  const iconContainerSize = sizeMap[size] || 'byte';

  return css`
    ${iconContainerSize};
  `;
};

const IconContainer = styled('div')(
  iconContainerBaseStyles,
  iconContainerErrorStyles,
  iconContainerSuccessStyles,
  iconContainerSizeStyles,
);

const iconSizeMap = {
  byte: 'xs',
  giga: 'sm',
  tera: 'sm',
};

const AlertIcon = ({ size, variant, icon }) => (
  <IconContainer size={size} variant={variant}>
    <Icon icon={icon} size={iconSizeMap[size]} />
  </IconContainer>
);

AlertIcon.propTypes = {
  size: PropTypes.string,
  variant: PropTypes.string,
  icon: PropTypes.string,
};

AlertIcon.defaultProps = {
  size: 'byte',
  icon: 'lock',
};

export default AlertIcon;
